import React, { useState, useEffect } from "react";
import {
  BetaForm as useBetaForm,
  TextInputBase,
  ButtonBase,
  PickerSelectSimple,
} from "@reusejs/react";
import { XIcon, CheckCircleIcon } from "@heroicons/react/solid";
import CallRequestModalSvg from "../../Icons/CallRequestModalSvg";
import { bidInterest } from "services";

export default function CallRequestModal(props: any) {
  const [requestCallback, setRequestCallback] = useState(false);
  const [requestCallbackSuccess, setRequestCallbackSuccess] = useState(false);
  console.log("check here props:", props.listing_id);
  const form = useBetaForm({
    mobile_number: "",
    isd_code: {
      label: "+91",
      value: "+91",
    },
  });

  const form_constraints = {
    mobile_number: {
      presence: {
        allowEmpty: false,
      },
      numericality: {
        onlyInteger: true,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const hanldeSubmit = async () => {
    try {
      if (form.validate()) {
        let payload: any = {
          property_id: props.listing_id ? props.listing_id : "",
        };
        let mobile = form.value.mobile_number;
        if (mobile.match(+91)) {
          payload["mobile_number"] = mobile;
        } else {
          payload["mobile_number"] = form.value.isd_code.value + mobile;
        }

        await bidInterest(payload).then((res) => {
          form.setField("mobile_number", "");
          setRequestCallbackSuccess(true);
        });
      }
    } catch (err) {
      console.log("check here err", err);
    }
  };
  return (
    <div className="min-w-full relative shadow-sm flex flex-col rounded-md border">
      <div className="flex-1">
        <div className="absolute z-10 -top-4 -right-2 sm:-right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900">
          <div className="cursor-pointer" onClick={() => props.closeCallback()}>
            <XIcon className="h-4 w-4" aria-hidden="true" />
          </div>
        </div>
        <div className="relative bg-gray-50 rounded-md">
          <div className="md:grid md:grid-cols-3 md:gap-12 md:items-start">
            <div className="flex items-center justify-center p-4">
              <div className="hidden lg:flex items-center scale-125 mr-4">
                <CallRequestModalSvg />
              </div>
              <div className="relative text-left ml-2">
                <h2 className="text-sm font-semibold tracking-tight">
                  Interested?
                </h2>
                <div className="mt-1 text-xs text-gray-500">
                  Request a callback
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row border-l-2 p-4 col-span-2">
              {requestCallbackSuccess ? (
                <div className="w-full px-12">
                  <div className="w-full p-3 rounded-lg text-sm bg-green-50 text-green-700 flex justify-between">
                    <div className="flex items-center">
                      <CheckCircleIcon
                        height={16}
                        width={16}
                        className="mr-2"
                      />
                      Thank you for your interest, we will reach out to you!
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {requestCallback && (
                    <div className="w-full mb-2 sm:mb-0 sm:w-[710px] mr-2 relative">
                      <TextInputBase
                        name={"mobile_number"}
                        onChange={(val) => form.setField("mobile_number", val)}
                        placeholder={"Enter your mobile"}
                        type={"text"}
                        error={
                          form.errors.get("mobile_number") ? (
                            <p className="mt-2 text-sm text-red-500">
                              {form.errors.get("mobile_number")[0]}
                            </p>
                          ) : null
                        }
                        value={form.getField("mobile_number")}
                        htmlFor={"mobile_number"}
                        textInputBaseClasses={{
                          padding: "pl-20",
                        }}
                        textInputPrefix={
                          <div className="w-20 absolute left-0 top-0 bottom-1 flex items-center ">
                            <div className="relative w-full">
                              <PickerSelectSimple
                                dataSource={(c) => {
                                  return [
                                    {
                                      label: "+91",
                                      value: "+91",
                                    },
                                  ];
                                }}
                                defaultSelected={[form.getField("isd_code")]}
                                onChange={(value) =>
                                  form.setField("isd_code", value)
                                }
                                pickerSelectSimpleClasses={{
                                  selectedDataClasses: {
                                    border:
                                      "border-l border-gray-300 dark:border-gray-600",
                                  },
                                }}
                                valueKey="value"
                                multiple={false}
                                enableClear={false}
                                enableClose={false}
                                enableSearch={false}
                                disabled={true}
                              />
                            </div>
                          </div>
                        }
                      />
                    </div>
                  )}
                  <div className="w-full mr-2 mb-2 sm:mb-0">
                    <ButtonBase
                      variant="primary"
                      type="submit"
                      label={requestCallback ? "Submit" : "Request a callback"}
                      onClick={() => {
                        if (requestCallback) {
                          hanldeSubmit();
                        } else {
                          setRequestCallback(true);
                        }
                      }}
                      buttonBaseClasses={{
                        font: "text-sm font-medium",
                        backgroundColor: "bg-blue-600 hover:bg-blue-700",
                        textColor: "text-white",
                        border: "any",
                        width: "w-full",
                        padding: "px-4 py-3",
                      }}
                    />
                  </div>
                  <div className="w-full mb-2 sm:mb-0">
                    <ButtonBase
                      variant="primary"
                      type="submit"
                      label="WhatsApp me"
                      onClick={() => {
                        const clientNumber = "+918370969696";
                        const baseurl = window.location.href
                          .split("/")
                          .filter(Boolean)[1];
                        const link =
                          "http://" +
                          baseurl +
                          "/auction-properties/" +
                          props.listing_id;
                        const whatsappMsg = `Hi Auctionbazaar,\n\nI am interested in knowing more about this property\n\n${link}`;

                        window.open(
                          `https://wa.me/${clientNumber}?text=${encodeURI(
                            whatsappMsg
                          )}`,
                          "_blank"
                        );

                        props.closeCallback();
                      }}
                      buttonBaseClasses={{
                        font: "text-sm font-medium",
                        backgroundColor: "bg-green-600 hover:bg-green-700",
                        textColor: "text-white",
                        border: "any",
                        width: "w-full",
                        padding: "px-4 py-3",
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
